import axios from 'axios';

/**
 * The Cost Allocation endpoints, built from the page's index and reports URLs.
 * Every mutation resolves to the server's stored state so the caller merges it
 * into what is on screen instead of reloading.
 */
export default function costAllocationApi(indexUrl, reportsUrl) {
    const report = (reportId) => `${reportsUrl}/${reportId}`;
    const column = (reportId, columnId) => `${report(reportId)}/fields/${columnId}`;

    return {
        index: () => axios.get(indexUrl, { headers: { Accept: 'application/json' } }).then((r) => r.data),
        showReport: (reportId) => axios.get(report(reportId)).then((r) => r.data),
        createReport: (payload) => axios.post(reportsUrl, payload).then((r) => r.data.report),
        renameReport: (reportId, title) => axios.put(report(reportId), { title }).then((r) => r.data.report),
        duplicateReport: (reportId) => axios.post(`${report(reportId)}/duplicate`).then((r) => r.data.report),
        deleteReport: (reportId) => axios.delete(report(reportId)).then((r) => r.data),
        exportReport: (reportId) => axios.get(`${report(reportId)}/export`, { responseType: 'blob' }),
        createColumn: (reportId, payload) => axios.post(`${report(reportId)}/fields`, payload).then((r) => r.data),
        updateColumn: (reportId, columnId, payload) => axios.put(column(reportId, columnId), payload).then((r) => r.data.column),
        deleteColumn: (reportId, columnId) => axios.delete(column(reportId, columnId)).then((r) => r.data),
        allocationCount: (reportId, columnId) => axios.get(`${column(reportId, columnId)}/allocation-count`).then((r) => r.data.count),
        updateAllocations: (reportId, columnId, payload) => axios.put(`${column(reportId, columnId)}/allocations`, payload).then((r) => r.data.allocations),
        updateLineNote: (reportId, lineKey, note) => axios.put(`${report(reportId)}/line-notes`, { line_key: lineKey, note }).then((r) => r.data),
    };
}

/** The first validation message per field from a 422 response, or null. */
export const validationErrors = (error) => {
    const errors = error?.response?.status === 422 ? error.response.data?.errors : null;

    if (!errors) {
        return null;
    }

    return Object.fromEntries(Object.entries(errors).map(([key, messages]) => [key, Array.isArray(messages) ? messages[0] : messages]));
};

/** A readable message for a failed request. */
export const errorMessage = (error, fallback) => {
    const errors = validationErrors(error);

    if (errors) {
        return Object.values(errors)[0];
    }

    return error?.response?.data?.message || fallback;
};
